
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/articles/authors/[slug]",
      function () {
        return require("private-next-pages/articles/authors/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/articles/authors/[slug]"])
      });
    }
  